<template>
  <el-card
    class="widget-card"
    :shadow="borderless ? 'never' : 'always'"
  >
    <div class="widget-header">
      <router-link
        v-if="titleLink"
        v-slot="{ navigate, href }"
        :to="titleLink"
        custom
      >
        <el-link
          :href="href"
          @click="navigate"
          >{{ title }}</el-link
        >
      </router-link>
      <el-link v-else>{{ title }}</el-link>
      <slot name="action" />
    </div>
    <div class="widget-content">
      <slot />
    </div>
  </el-card>
</template>

<script setup>
const props = defineProps({
  title: String,
  titleLink: String,
  borderless: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped>
.widget-card {
  margin: 10px;
}

.widget-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.indicator {
  margin-top: 10px;
}

@media (max-width: 767px) {
  .widget-card {
    margin: 8px 0;
  }
}
</style>
